import { Fragment, useEffect, useState, useRef } from 'react'
import { FormControl, InputLabel, Select } from '@mui/material';

import { useNavigate } from 'react-router-dom'
import Papa from 'papaparse'
import * as XLSX from 'xlsx'

// ** MUI Components
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import MuiCard from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { styled } from '@mui/material/styles'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import FormHelperText from '@mui/material/FormHelperText'
import Tooltip from '@mui/material/Tooltip';
import { DataGrid } from '@mui/x-data-grid'
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuList from '@mui/material/MenuList'
import ButtonGroup from '@mui/material/ButtonGroup'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import MuiTabList from "@mui/lab/TabList";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import AddIcon from "@mui/icons-material/Add";
import Avatar from '@mui/material/Avatar'
import AddEmployeeDoodle from "images/AddEmployeeDoodle.png";
import AddCustomerDialog from 'screens/Customers/component/AddCustomer';
import { useIndexLogic } from 'screens/Customers/logic/indexLogic';
import { DeleteCustomer } from 'screens/Customers/logic/DeleteCustomer';
import { Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, } from '@mui/material';
  import { useTheme } from '@mui/material/styles';

// ** Custom Cumponent Imports
import CustomTextField from '../../../../components/mui/text-field'
import ServerSideToolbar_WithoutSearch from '../../../../components/data-grid/ServerSideToolbar_WithoutSearch'
import CustomChip from "components/mui/chip";

// ** Icon Imports
import Icon from '../../../../components/icon'

// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import { useDropzone } from 'react-dropzone'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { dev_baseUrl } from 'utils/var';



// ** Styled Components
const Card = styled(MuiCard)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: '100%' }
}))

const TabList = styled(MuiTabList)(({ theme }) => ({
  borderBottom: "0 !important",
  width: '90%',
  display: 'flex',
  justifyContent: 'center',
  "&, & .MuiTabs-scroller": {
    boxSizing: "content-box",
    padding: theme.spacing(1.25, 1.25, 2),
    margin: `${theme.spacing(-1.25, -1.25, -2)} !important`,
    backgroundColor: '#F3F4F4',
    maxWidth: 'max-content',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    justifyContent: 'center',
    // Responsive padding for mobile
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 1, 1.5),
      margin: `${theme.spacing(-1, -1, -1.5)} !important`,
    }
  },
  "& .MuiTabs-flexContainer": {
    justifyContent: 'center',
    // Reduce gap between tabs on mobile
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.5),
    }
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .Mui-selected": {
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.common.white,
    color: `${theme.palette.main.main} !important`,
  },
  "& .MuiTab-root": {
    display: 'flex',
    justifyContent: 'center',
    lineHeight: 1,
    borderRadius: theme.shape.borderRadius,
    // Smaller padding and min-height for mobile
    [theme.breakpoints.down('sm')]: {
      minHeight: '36px',
      padding: theme.spacing(0.75, 1.5),
      fontSize: '0.8rem',
    },
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
}));

const StepAddCustomer = ({ handlePrev }) => {
  // ** Hooks
  const theme = useTheme();
  const MySwal = withReactContent(Swal);

  // ** States
  const [files, setFiles] = useState([])
  const [alignment, setAlignment] = useState('enterManually')
  const [dataEntryAlignment, setDataEntryAlignment ] = useState('enterManually')

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [rows, setRows] = useState([]); 
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [openErrorListDlg, setOpenErrorListDlg] = useState(false);
  const [openErrorImport, setOpenErrorImport] = useState(false);
  const [selectedIndexErrorImport, setSelectedIndexErrorImport] = useState(1);
  const [errorMessages, setErrorMessages] = useState([]);
  const [userType, setUserType] = useState('User');
  const [openSuccessListDlg, setOpenSuccessListDlg] = useState(false);
  const [successMessages, setSuccessMessages] = useState('');
  const [isDataModified, setIsDataModified] = useState(false);
  const { IndexProps } = useIndexLogic({ toast });
  const [filteredRows, setFilteredRows] = useState([]);
  const [customerPaginationModel, setCustomerPaginationModel] = useState({
    page: 0,
    pageSize: 10
  })

  const optionsErrorImport = ['Export report as CSV', 'Export report as XLSX']

  const anchorRefErrorImport = useRef(null)

  const handleClickErrorImport = () => {
    console.info(`You clicked ${optionsErrorImport[selectedIndexErrorImport]}`)
  }

  const handleMenuItemClickErrorImport = (event, index) => {
    setSelectedIndexErrorImport(index)
    setOpenErrorImport(false)
  }

  const handleToggleErrorImport = () => {
    setOpenErrorImport(prevOpen => !prevOpen)
  }

  const handleCloseErrorImport = () => {
    setOpenErrorImport(false)
  }

   const { handleOpenNewCustomerDlg, setOpenNewCustomerDlg, openNewCustomerDlg, allCustomers, handleCloseNewCustomerDlg, fetchData } = IndexProps;

  useEffect(() => {
    if(allCustomers){
      setFilteredRows(() => allCustomers.map((customer, index) => ({
        ...customer,
        id: index,
      })))
    }
  }, [allCustomers])
  

  const navigate = useNavigate();

  const handleAlignment = (event, newAlignment) => {
    if( newAlignment != null  )
      {        
        setAlignment(newAlignment)
        setDataEntryAlignment(newAlignment)
        setFiles([])
      }
  }
  
  const handlePrevious = () => {    
    if (rows.length > 0 || files.length > 0) {
      if (window.confirm("Are you sure you want to go back? Your changes might not be saved.")) {
        handlePrev();
      }
    } else {
      handlePrev();
    }
    
  }

  useEffect(() => {
    if (message || Object.keys(errors).length > 0) {
      const timer = setTimeout(() => {
        setMessage('');        
        setErrors({});
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message, errors]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDataModified) {
      
        e.preventDefault(); 
        e.returnValue = ''; 
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDataModified]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDataModified) {
        e.preventDefault();
        e.returnValue = ''; 
      }
    };

    const handlePopState = () => {
      if (isDataModified) {
        const shouldNavigate = window.confirm("Are you sure you want to go back? Your changes might not be saved.");
        if (!shouldNavigate) {
          window.history.pushState(null, '', window.location.href);
        }
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isDataModified]);
  
  // ** Dropzone configuration
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 2000000, // 2 MB in bytes
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onDrop: acceptedFiles => {
      setLoading(true);  
      setTimeout(() => {
        setFiles(acceptedFiles.map(file => Object.assign(file)));
        setLoading(false); 
        setIsDataModified(true);
      }, 1000);  // Simulating a delay for loading effect
    },
    onDropRejected: () => {
      toast.error('You can only upload 1 file with a maximum size of 2 MB.', {
        duration: 2000,
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
      setMessage('You can only upload 1 file with a maximum size of 2 MB.');
      setLoading(false);
    }
  })

  const handleFileParse = async () => {
    
    const file = files[0]
    if (!file) {
      setMessage('Please select file to perform this action.');
      return
    }
  
    let parsedData = []
  
    const renameKeys = (data) => {
      return data.map(row => {
        const newRow = {}
        const keyGroups = {}
  
        // First, group keys by base name (e.g., 'Name', 'Email') and collect their numbers
        for (let key in row) {
          const match = key.match(/(.+)_([0-9]+)/)
          if (match) {
            const baseKey = match[1]
            const number = parseInt(match[2])
  
            // Group keys by their base name and track the sequence of numbers
            if (!keyGroups[baseKey]) {
              keyGroups[baseKey] = []
            }
            keyGroups[baseKey].push(number)
          } else {
            // If the key doesn't have a number, it's the base key (e.g., 'Name')
            keyGroups[key] = [0]  // Treat the base key as number 0
          }
        }
  
        // Now, iterate over the original row and rename keys based on the sequence
        for (let key in row) {
          const match = key.match(/(.+)_([0-9]+)/)
          if (match) {
            const baseKey = match[1]
            const number = parseInt(match[2])
  
            // Check if this key is part of a valid sequence
            const numbers = keyGroups[baseKey].sort((a, b) => a - b)
            const isValidSequence = numbers.every((num, index) => num === index)
  
            if (isValidSequence) {
              // If it's a valid sequence, rename the key with an incremented number
              newRow[`${baseKey}_${number + 1}`] = row[key]
            } else {
              // If it's not a valid sequence, keep the original key
              newRow[key] = row[key]
            }
          } else {
            // If the key doesn't have a number, keep it as is
            newRow[key] = row[key]
          }
        }
        return newRow
      })
    }
  
    if (file.type === 'text/csv') {
      Papa.parse(file, {
        skipEmptyLines: true,
        header: true,
        complete: (result) => {
          parsedData = renameKeys(result.data)
          navigateToNextPage(parsedData)
          setLoading(false)
        }
      })
    } else if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
    
        // Parse with header row and default value for empty cells
        let dataRows = XLSX.utils.sheet_to_json(worksheet, {
          header: 1,
          defval: '',
        });
    
        // Extract headers and map rows
        const headers = dataRows[0];
        const rows = dataRows.slice(1).map(row =>
          headers.reduce((acc, key, i) => {
            acc[key] = row[i] || '';
            return acc;
          }, {})
        );
    
        parsedData = renameKeys(rows);        
        navigateToNextPage(parsedData);
        setLoading(false);
      };
      reader.readAsArrayBuffer(file);
    }
  }  

  const navigateToNextPage = (data) => {  
    
    if(dataEntryAlignment==="uploadFile"){
      navigate('/onboarding/add-customer', { state: { data } })
    }
    if(dataEntryAlignment==="bulkUploadJobsiteFile"){
      navigate('/onboarding/add-customer-with-jobsites', { state: { data } })
    } 
    if(dataEntryAlignment==="bulkUploadContactFile"){
      navigate('/onboarding/add-customer-with-contacts', { state: { data } })
    } else {

    }
    
  }

  const handleSkip = () => {    
    if (rows.length > 0 || files.length > 0) {
      if (window.confirm("Are you sure you want to skip? Your changes might not be saved.")) {
        navigate('/Dashboard');
      }
    } else {
      navigate('/Dashboard');
    }
  }

  // Render file preview
  const renderFilePreview = file => {
    return <Icon icon='tabler:file-description' fontSize={20} />
  }

  // Handle file removal
  const handleRemoveFile = file => {
    const filteredFiles = files.filter(i => i.name !== file.name)
    setFiles(filteredFiles)
  }

  const columns = [
    {
      field: "firstName",
      minWidth: 120,
      headerName: "First Name",
      renderCell: ({ row }) => {
        const { firstName } = row;
        
        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%", 
              cursor:'pointer' , 
          }}
          >
            <Typography>{firstName || '-'}</Typography>
          </Box>
        );
      },
    },
    {
      field: "lastName",
      minWidth: 120,
      headerName: "Last Name",
      renderCell: ({ row }) => {
        const { lastName } = row;
        
        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%",
            }}
          >
            <Typography>{lastName || '-'}</Typography>
          </Box>
        );
      },
    },
    {
      field: "companyName",
      minWidth: 160,
      headerName: "Company Name",
      renderCell: ({ row }) => {
        const { companyName } = row;
        
        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%",
            }}
          >
            <Typography>{companyName || '-'}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "customerType",
      minWidth: 120,
      headerName: "Type",
      renderCell: ({ row }) => {
        const { customerType } = row;
        return (
          <>
            <CustomChip
              rounded
              size="small"
              skin="dark"
              sx={{ lineHeight: 1, cursor: 'pointer' }}
              color={customerType === "Individual" ? "warning" : "info"} //'success' // Use color names: primary, secondary, error, warning, info, success
              label={customerType}
            />
          </>
        );
      },
    },
    {
      flex: 0.1,
      field: "email",
      minWidth: 120,
      headerName: "Email",
      renderCell: ({ row }) => {
        const { email } = row;
        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%",
            }}
          >
            <Typography>{email}</Typography>
          </Box>
        );
      },
    },
    {
      flex: 0.1,
      field: "phoneNumbers",
      minWidth: 120,
      headerName: "Phone",
      renderCell: ({ row }) => {
        const { phoneNumbers } = row;
        
        const phone = phoneNumbers.find((phone) => phone.isPrimary)
        return (
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              height: "100%",
            }}
          >
            <Typography>{phone.phoneNo}</Typography>
          </Box>
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 100,
      renderCell: ({ row }) => {
        const { customerID } = row;

        return(
          <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
            <IconButton onClick={() => removeCustomerConfirmation(customerID)} color='error'>
              <Icon icon='tabler:trash' />
            </IconButton>
          </Box>
        )
      },
    },
  ];

  const errorColumns = [

    {
      flex: 0.25,
      minWidth: 180,
      field: 'email',      
      headerName: 'Email'
    },

    {
      flex: 0.25,
      minWidth: 180,      
      headerName: 'Reason',
      field: 'failureReason'
    }       
  ]

  const validateName = (name, field, userType) => {
    const errors = {};
    const forbiddenKeywords = ["Select", "Update", "Delete", "INSERT", "Drop"];
    const nameRegex = /^[A-Za-z\s'-]+$/;
  
  
    if (field === "companyName" && userType === "individual") {
      return errors; // No errors for companyName if userType is Individual
    }
  
    if (!nameRegex.test(name)) {
      errors[field] = `${field === "firstName" ? "First Name" : field === "lastName" ? "Last Name" : field === "companyName" ? "Company Name" : "Field"} cannot contain special characters.`;
    }
  
    if (forbiddenKeywords.some((word) => name.toLowerCase().includes(word.toLowerCase()))) {
      errors[field] = `Invalid Input.`;
    }
  
    if ((name && name.trim().length) < 2 || (name && name.trim().length) > 50) {
      errors[field] = `${field === "firstName" ? "First Name" : field === "lastName" ? "Last Name" : field === "companyName" ? "Company Name" : "Field"} must be between 2 and 50 characters.`;
    }
  
    if (!name.trim()) {
      errors[field] = `${field === "firstName" ? "First Name" : field === "lastName" ? "Last Name" : field === "companyName" ? "Company Name" : "Field"} cannot be empty or only spaces.`;
    }
  
    if (!name) {
      errors[field] = `${field === "firstName" ? "First Name" : field === "lastName" ? "Last Name" : field === "companyName" ? "Company Name" : "Field"} is required.`;
    }
  
    return errors;
  };
  
  const handleAddCustomer = () => {
    const newErrors = {};

    const firstNameErrors = validateName(firstName, "firstName", userType);
    if (Object.keys(firstNameErrors).length > 0) {
      newErrors.firstName = firstNameErrors.firstName;
    }
  
    // Apply validation for Last Name
    const lastNameErrors = validateName(lastName, "lastName", userType);
    if (Object.keys(lastNameErrors).length > 0) {
      newErrors.lastName = lastNameErrors.lastName;
    }

    // Apply validation for Company Name
    const companyNameErrors = validateName(companyName, "companyName", userType);
    
    if (Object.keys(companyNameErrors).length > 0) {
      newErrors.companyName = companyNameErrors.companyName;
    }

    if ((!email)) {      
      newErrors.email = 'Email is required.';
    }

    if ((!userType || userType === '' || userType === 'User')) {            
      newErrors.userType = 'Customer Type is required.';
    }

    if (!phone || phone.trim() === '') {
      newErrors.phone = 'Phone number is required';
    } else if (phone.length < 10) {
      newErrors.phone = 'Invalid phone number.';
    } else if (phone.charAt(0) === '1') {
      newErrors.phone = 'Area code cannot begin with 1.';
    } else if (phone.length === 10) {

    } else {
        newErrors.phone = 'Phone number should be 10 digits';
    }
  
    // Email validation (simple regex)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      newErrors.email = 'Please enter a valid email.';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }
 
    const newCustomer = {
      id: rows.length + 1, 
      firstName,
      lastName,
      companyName,
      customerType: userType,
      email,
      phone
    };

    setRows([...rows, newCustomer]);
    
    // For page reload
    setIsDataModified(true);

    // Clear input fields
    setFirstName('');
    setLastName('');
    setCompanyName('');
    setEmail('');
    setPhone('');
    setUserType('User');
  };

  const removeCustomerConfirmation = (id) => {
    MySwal.fire({
      title: '<strong>Are you sure?</strong>',
      html: '<span>You won\'t be able to revert this!</span>',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      width: '390px',
      padding: '1rem',
      focusConfirm: false,
      showCloseButton: true,
      closeButtonHtml: '&times;',
      customClass: {
        popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteCustomer(id);        
      }
    });
  }

  const handleDeleteCustomer = async (id) => {
    setLoading(true);

    try{
      const response = await DeleteCustomer(id, navigate);

      if(response){
        toast.success("Customer Deleted Successfully!", {
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
        fetchData();
      }else{
        toast.error("Failed to delete the Customer!", {
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
      }
    }catch(error){
      console.error(error)
    }finally{
      setLoading(false);
    }
  };


  const handleChangeCustomerType = (event) => {
    setUserType(event.target.value);
};
  const handleSaveCustomers = async () => {

  const token = localStorage.getItem('jwtToken');

    if (!token) {
      // If there's no token, redirect to login page
      setLoading(true);  
      navigate('/login', { state: { message: 'Session expired, please login again.' } });
      return;
    }
    
    if(rows.length <= 0) {
      setMessage('Atleast one customer is required to perform this action.');
      return;
    }

    for (const row of rows) {
      if (!row.firstName) {
        setMessage(`Please fill in First Name in row: ${row.id}`);
        return;
      }
      if (!row.lastName) {
        setMessage(`Please fill in Last Name in row: ${row.id}`);
        return;
      }
      if (!row.companyName && row.customerType !== 'individual') {
        setMessage(`Please fill in Company Name in row: ${row.id}`);
        return;
      }
      if (!row.email) {
        setMessage(`Please fill in Email in row: ${row.id}`);
        return;
      } 
      if (!row.customerType) {
        setMessage(`Please fill in customer type in row: ${row.id}`);
        return;
      }      
  
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (row.email && !emailRegex.test(row.email)) {
        setMessage(`Please enter a valid email in row: ${row.id}`);
        return;
      }
      
    }

    const apiPayload = rows.map((row) => {
      const phoneValue = row.phone || null;
      const isInvalidPhone = 
            !phoneValue || 
            phoneValue.trim() === '' || 
            phoneValue.length < 10 || 
            phoneValue === '1' || 
            phoneValue.length !== 10;
    
      return {
        isActive: true,
        customerID: 0,
        firstName: row.firstName || null,
        lastName: row.lastName || null,
        companyName: row.companyName || "",
        customerType: row.customerType || null,
        email: row.email || null,
        phoneNumbers: [{phoneNo: (isInvalidPhone ? null : `1${phoneValue}` || null),
          isPrimary: (isInvalidPhone ? false : true || null)
        }],        
        isLead: false,
      };
    });
    
    
    setLoading(true);
    console.log("API Payload: "+ JSON.stringify(apiPayload))
    try {
  
      const response = await fetch(`${dev_baseUrl}/Customer/saveCustomer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(apiPayload),            
      });
  
      if (response.status === 400) {
        // Handle validation error
        const errorResponse = await response.json();
        console.error('Validation Error:', errorResponse);
  
        // Extract error details
        const validationErrors = errorResponse.errors || {};
        const errorMessages_1 = Object.keys(validationErrors).map((key) => {
          const errorList = validationErrors[key].join(', ');
          return `${key}: ${errorList}`;
        });
  
        // setErrorDetails(errorMessages);
        setMessage('Validation errors occurred. Please check your input.');
        return;
      }
  
      if (response.status === 401) {
        // Token is invalid or expired, redirect to login
        navigate('/login', { state: { message: 'Session expired, please login again.' } });
        return;
      }
      
      if (!response.ok) {
        const errorMessage = `Error ${response.status}: ${response.statusText}`;
        console.error(errorMessage);
        setMessage('Failed to save customer data. Please try again.');
      }
  
      const result = await response.json();
      console.log("API Response:", result);
      
      if (result.isError) {
        const failureMessages = result.result
            .filter(item => item.failureReason) 
            .map(item => `${item.firstName} ${item.lastName}: ${item.failureReason}`); 

        if (failureMessages.length > 0) {
          const errorMessagesWithIds = result.result.map((row, index) => ({
            ...row,
            id: index, 
          }));
        
          setErrorMessages(errorMessagesWithIds);
          setOpenErrorListDlg(true); 
          return;
            
        }
    }
      setMessage('Data saved successfully!');
      sessionStorage.removeItem('myStep');
      setSuccessMessages(result?.message || 'All customers saved successfully.');
      setOpenSuccessListDlg(true);    

    } catch (error) {
      console.error("Error:", error);
      setMessage('An error occurred while saving data. Please try again.');
    } finally {
      setLoading(false); 
    }
  };
  
  const handleProcessRowUpdate = (newRow, oldRow) => {
    const updatedRows = rows.map((row) =>
      row.id === oldRow.id ? newRow : row
    );
    setRows(updatedRows);
    return newRow;
  };
  
  const handleOpenErrorListDlg = () => {
    setOpenErrorListDlg(true)
  }

  const handleCloseErrorListDlg = () => {
    setOpenErrorListDlg(false);
    navigate('/Dashboard');
  }

  const handleCloseSuccessListDlg = () => {

    setOpenSuccessListDlg(false);
    navigate('/Dashboard');
  }

  // File list component
   const fileList = files.map((file) => (
   <Box
      key={file.name}
      sx={{
        border: '1px solid #E1E4EA',
        borderRadius: 1,
        px: 6,
        py: 4,
        mx: 'auto',
        minWidth: {xs: 250, sm: 300},
        maxWidth: 'max-content',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            mr: 6,
          }}
        >
          <Box>
            {renderFilePreview(file)}
          </Box>
          <Box>
            <Tooltip title={file.name}>
              <Typography 
                variant='body1'
                sx={{
                  maxWidth: '300px',
                  whiteSpace: {xs: 'wrap', sm: 'nowrap'},
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'inline-block'
                }}
              >
                {file.name}
              </Typography>
            </Tooltip>
            <Typography variant="body1" color="text.secondary">
              {Math.round(file.size / 100) / 10 > 1000
                ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
                : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
            </Typography>
          </Box>
        </Box>
        <Tooltip title="Remove">
          <IconButton onClick={() => handleRemoveFile(file)}
             color="error">
            <Icon icon="tabler:trash" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  ));

  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          py: 3,
          pt: { xs: 3, sm: "30px", md: "30px", lg: 2, xl: 2 },
        }}
      >
        {message && (
          <Box mb={2} textAlign="center">
            <Typography
              variant="h6"
              color={message.includes("successfully") ? "green" : "red"}
            >
              {message}
            </Typography>
          </Box>
        )}
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: { xs: "flex-start", sm: "center" },
                maxWidth: { xs: "100%", lg: "57%" },
                mx: "auto",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: "white",
                    border: "1px solid #e0e0e0",
                    color: "text.primary",
                    height: 50,
                    width: 50,
                  }}
                >
                  <Icon icon="tabler:users" />
                </Avatar>
                <Box>
                  <Typography variant="h5">Add Customers</Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    Last, but not least! Add your customers to get started.
                  </Typography>
                </Box>
              </Box>
              <Button
                variant="contained"
                color="main"
                startIcon={<AddIcon />}
                onClick={handleOpenNewCustomerDlg}
                sx={{
                  ml: { xs: 0, sm: 9 },
                  px: 3,
                  width: { xs: "100%", sm: "auto" },
                  mt: { xs: 2, sm: 0 },
                }}
              >
                New Customer
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TabContext value={alignment}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <TabList
                  centered
                  onChange={handleAlignment}
                  aria-label="customized tabs example"
                >
                  <Tab value="enterManually" label="Add Customers" />
                  
                  <Tab value="uploadFile" label="Import Customers" />
                  
                  <Tab value="bulkUploadJobsiteFile" label="Import Customers with Jobsites" />

                  <Tab value="bulkUploadContactFile" label="Import Customers with Contacts" />
                </TabList>
              </Box>
              <TabPanel value="enterManually" sx={{ px: 0 }}>
                {filteredRows.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mx: "auto",
                      border: "1px solid #EAEAEA",
                      borderRadius: 1,
                      maxWidth: { xs: "100%", lg: "60%" },
                      height: 220,
                      py: 4,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={AddEmployeeDoodle}
                        alt="Empty State"
                        style={{ width: "100px", height: "auto" }}
                      />
                      <Typography variant="h6">
                        No Customers added yet
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <DataGridPro
                      columns={columns}
                      rows={filteredRows}
                      pageSizeOptions={[
                        10,
                        25,
                        50,
                        { label: "Show All", value: filteredRows.length },
                      ]}
                      paginationModel={customerPaginationModel}
                      onPaginationModelChange={setCustomerPaginationModel}
                      processRowUpdate={(newRow, oldRow) =>
                        handleProcessRowUpdate(newRow, oldRow)
                      }
                      onProcessRowUpdateError={(error) => console.error(error)} // Optional: Error handling
                      experimentalFeatures={{ newEditingApi: true }}
                      sx={{
                        "& .MuiDataGrid-columnHeaderTitle": {
                          textTransform: "none",
                        },
                        minHeight: 250,
                        maxHeight: 350,
                        maxWidth: { xs: "100%", lg: "60%" },
                      }}
                    />
                  </Box>
                )}
              </TabPanel>
              <TabPanel value="uploadFile" sx={{ px: 0 }}>
                <Box
                  {...getRootProps({ className: "dropzone" })}
                  sx={{
                    border: "1px dashed #CACFD8",
                    borderRadius: 1,
                    py: 6,
                    px: 2,
                    maxWidth: { xs: "100%", lg: "60%" },
                    mx: "auto",
                    cursor: "pointer",
                    height: 220,
                  }}
                >
                  <input {...getInputProps()} />
                  <Box
                    textAlign="center"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%", // Ensure it takes full height of parent
                      gap: 2, // Adds spacing between items (optional)
                    }}
                  >
                    <Icon icon="tabler:cloud-upload" fontSize="2.5rem" />
                    <Typography variant="h6">
                      Click and choose a file or drag and drop it here.
                    </Typography>
                    <Typography variant="body2">
                      Only CSV and XLSX formats, up to 2MB.
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {files.length ? (
                    <>
                      <List>{fileList}</List>
                    </>
                  ) : null}
                </Box>
              </TabPanel>
                  {/* Import Customers with Jobsites */}
              <TabPanel value="bulkUploadJobsiteFile" sx={{ px: 0 }}>
                <Box
                  {...getRootProps({ className: "dropzone" })}
                  sx={{
                    border: "1px dashed #CACFD8",
                    borderRadius: 1,
                    py: 6,
                    px: 2,
                    maxWidth: { xs: "100%", lg: "60%" },
                    mx: "auto",
                    cursor: "pointer",
                    height: 220,
                  }}
                >
                  <input {...getInputProps()} />
                  <Box
                    textAlign="center"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%", // Ensure it takes full height of parent
                      gap: 2, // Adds spacing between items (optional)
                    }}
                  >
                    <Icon icon="tabler:cloud-upload" fontSize="2.5rem" />
                    <Typography variant="h6">
                      Click and choose a file or drag and drop it here.
                    </Typography>
                    <Typography variant="body2">
                      Only CSV and XLSX formats, up to 2MB.
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {files.length ? (
                    <>
                      <List>{fileList}</List>
                    </>
                  ) : null}
                </Box>
              </TabPanel>

              <TabPanel value="bulkUploadContactFile" sx={{ px: 0 }}>
                <Box
                  {...getRootProps({ className: "dropzone" })}
                  sx={{
                    border: "1px dashed #CACFD8",
                    borderRadius: 1,
                    py: 6,
                    px: 2,
                    maxWidth: { xs: "100%", lg: "60%" },
                    mx: "auto",
                    cursor: "pointer",
                    height: 220,
                  }}
                >
                  <input {...getInputProps()} />
                  <Box
                    textAlign="center"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%", // Ensure it takes full height of parent
                      gap: 2, // Adds spacing between items (optional)
                    }}
                  >
                    <Icon icon="tabler:cloud-upload" fontSize="2.5rem" />
                    <Typography variant="h6">
                      Click and choose a file or drag and drop it here.
                    </Typography>
                    <Typography variant="body2">
                      Only CSV and XLSX formats, up to 2MB.
                    </Typography>
                  </Box>
                </Box>
                <Box>
                  {files.length ? (
                    <>
                      <List>{fileList}</List>
                    </>
                  ) : null}
                </Box>
              </TabPanel>
            </TabContext>
          </Grid>
        </Grid>
      </Box>
      <Grid item xs={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row", // same everywhere
              justifyContent: "space-between",
              alignItems: "center",
              width: { xs: "100%", lg: "60%" },
              gap: 2,
            }}
          >
            <Button
              variant="text"
              color="secondary"
              onClick={handlePrev}
              sx={{
                "& svg": { mr: 2 },
              }}
            >
              {/* <Icon fontSize="1.125rem" icon="tabler:arrow-left" /> */}
              Previous
            </Button>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: { xs: 2, sm: 0 },
              }}
            >
              <Button
                variant="text"
                color="secondary"
                size="small"
                onClick={() => navigate("/dashboard")}
              >
                Skip for Now
              </Button>
              <Button
                variant="contained"
                color="main"
                onClick={() => {
                  if (dataEntryAlignment === "uploadFile" || dataEntryAlignment === "bulkUploadJobsiteFile" || dataEntryAlignment === "bulkUploadContactFile"){
                    return handleFileParse();
                  } else {
                    navigate("/dashboard")
                  }
                }}
              >
                {dataEntryAlignment === "enterManually" ? "Next" : "Import"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>

      {/*<ToastContainer />*/}

      {/* Error List Dialog */}
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={openErrorListDlg}
        onClose={handleCloseErrorListDlg}
        aria-labelledby="form-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "650px", // Custom maxWidth between sm and md
            width: "100%", // Ensures it’s responsive within the set max width
          },
        }}
      >
        <DialogTitle>
          <Typography variant="h4" fontWeight="bold">
            Save Unsuccessful
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={5}>
            <Grid item xs={12}>
              <Typography variant="h6">
                The following customers will be skipped due to the reasons
                listed below.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <DataGridPro
                autoHeight
                rows={errorMessages}
                getRowId={(row) => row.id}
                columns={errorColumns}
                sx={{
                  "& .MuiDataGrid-columnHeaderTitle": {
                    textTransform: "none",
                    fontWeight: "bold",
                  },
                  maxWidth: "600px",
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "flex-end" }}
          className="dialog-actions-dense"
        >
          <Button
            variant="contained"
            color="main"
            onClick={handleCloseErrorListDlg}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <AddCustomerDialog
        open={openNewCustomerDlg}
        setOpenNewCustomerDlg={setOpenNewCustomerDlg}
        fetchData={fetchData}
        allCustomers={allCustomers}
      />
      {/* Success List Dialog */}
      <Dialog
        fullWidth={true}
        maxWidth="xs"
        open={openSuccessListDlg}
        onClose={handleCloseSuccessListDlg}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          <Typography variant="h4" fontWeight="bold">
            Customer Import Success
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Fragment>{successMessages}</Fragment>
        </DialogContent>
        <DialogActions
          sx={{ display: "flex", justifyContent: "flex-end" }}
          className="dialog-actions-dense"
        >
          <Button
            variant="contained"
            color="main"
            onClick={handleCloseSuccessListDlg}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}

export default StepAddCustomer